import { FC, ReactNode } from "react";
import { Flex } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
}

export const ContentWrapper: FC<Props> = ({ children }) => {
  return (
    <Flex direction="column" maxW="48rem" mb={{ base: 6, md: 12 }} w="full">
      {children}
    </Flex>
  );
};